import { getCurrentStep } from './helpers'

const Heading = ({ step, steps }) => <h2 className="cc-heading--step">{getCurrentStep(step, steps)}</h2>

export default Heading
